import { TypographyComponent } from "@gx1/gx-ui-common";
import { Fragment } from "react";
import { useTranslation } from "react-i18next";
import { SignupTokenType } from "../sign-up-v4.constants";
import { useSignupToken } from "../hooks/use-signup-token.hook";
import GartnerBuySmartLogoSVG from "../../../assets/images/gartner-buy-smart-logo.svg";
import styles from "./welcome-message.styles.module.scss";

const WelcomeMessageComponent = () => {
  const { t } = useTranslation();
  const { signupTokenType, decodedToken } = useSignupToken();

  return (
    <div className={styles.messageContainer}>
      <div className={styles.imgContainer}>
        <img alt={t("Gartner BuySmart logo")} src={GartnerBuySmartLogoSVG} />
      </div>
      {
        signupTokenType === SignupTokenType.FREE_TRIAL && (
          <Fragment>
            <TypographyComponent boldness="semi" color="white" element="h1" styling="h3-xl">
              {t("Welcome to your")}
              {` `}
              <TypographyComponent boldness="semi" color="opal" element="span" styling="h3-xl">
                {t("Gartner BuySmart")}
              </TypographyComponent>
              {` `}
              {t("Free Trial")}
            </TypographyComponent>
            <div className={styles.divider} />
            <TypographyComponent boldness="semi" color="white" styling="p-lg">
              {t("Start exploring the platform Gartner clients use to streamline their teams path to better technology buying decisions.")}
            </TypographyComponent>
          </Fragment>
        )
      }
      {
        signupTokenType === SignupTokenType.INVITE_SURVEY && (
          <Fragment>
            <TypographyComponent boldness="semi" color="white" element="h1" styling="h3-xl">
              {t("Join hundreds of other vendors")}
              {` `}
              <br />
              <TypographyComponent color="opal" boldness="semi" element="span" styling="h3-xl">
                {t("engaging with prospects")}
              </TypographyComponent>
              {` `}
              {t("on BuySmart.")}
            </TypographyComponent>
          </Fragment>
        )
      }
      {
        signupTokenType === SignupTokenType.INVITE_INITIATIVE && (
          <Fragment>
            <TypographyComponent boldness="semi" color="white" element="h1" styling="h3-xl">
              <TypographyComponent boldness="semi" color="opal" element="span" styling="h3-xl">
                {decodedToken?.invitedBy}
              </TypographyComponent>
              {` `}
              {t("has invited you to an evaluation on Gartner BuySmart!")}
            </TypographyComponent>
            <div className={styles.divider} />
            <TypographyComponent color="crystal" styling="p-xs">
              {t("Evaluation")}
            </TypographyComponent>
            <TypographyComponent boldness="semi" color="white" styling="p-lg">
              {decodedToken?.initTitle}
            </TypographyComponent>
          </Fragment>
        )
      }
    </div>
  );
};

export default WelcomeMessageComponent;
